module.exports = __webpack_public_path__ + "media/homepage/est-1995-badge_2x-18012971.webp";